import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from '@portals/core';
import { IStepOption, TourService } from 'ngx-ui-tour-ng-bootstrap';

@Component({
	selector: 'jotto-onboard',
	templateUrl: './jotto-onboard.component.html',
	styleUrls: ['./jotto-onboard.component.scss'],
})
export class JottoOnboardComponent extends BaseComponent implements OnInit {
	constructor(public dialog: MatDialog, public tourService: TourService) {
		super();
	}

	ngOnInit() {}

	startTour() {
		this.tourService.start();
		this.tourService.disableHotkeys();
	}
}
